import type { Beneficiary, SettlementRail } from "../api/types";
import { t } from "../i18n";
import { shortHash } from "./format";

const NET_SHORT: Record<string, string> = { tron: "Tron", ethereum: "Ethereum", polygon: "Polygon", solana: "Solana" };

export function networkShort(n: string | undefined | null): string {
  if (!n) return "";
  return NET_SHORT[n] ?? n;
}

/** "USDT · Tron" ou "ACH · Wells Fargo" */
export function railLabel(rail: SettlementRail | null | undefined): string {
  if (!rail) return "—";
  if (rail.kind === "stablecoin") return `${rail.asset} · ${networkShort(rail.network)}`;
  const scheme = t.suppliers.schemes[rail.scheme] ?? rail.scheme.toUpperCase();
  const bank = rail.account?.bankName;
  return bank ? `${scheme} · ${bank}` : scheme;
}

/** Destino resumido: "TQn9…3kLp" ou "conta ····4471" */
export function railDestination(rail: SettlementRail | null | undefined): string {
  if (!rail) return "—";
  if (rail.kind === "stablecoin") return shortHash(rail.address, 4, 4);
  const acc = rail.account?.accountNumber ?? rail.account?.iban ?? "";
  return acc ? `conta ····${acc.slice(-4)}` : "—";
}

/** Prazo por trilho (tabela da Lumx: ACH 1–2 dias úteis, Fedwire mesmo dia, SWIFT 1–5 dias úteis; stablecoin em minutos). */
export function railSla(rail: SettlementRail | null | undefined): string {
  if (!rail) return "";
  if (rail.kind === "stablecoin") return t.suppliers.slaStable;
  return t.suppliers.schemeSla[rail.scheme] ?? "";
}

export function railAsset(rail: SettlementRail | null | undefined): string {
  if (!rail) return "USD";
  return rail.kind === "stablecoin" ? rail.asset : "USD";
}

export function railNetworkName(rail: SettlementRail | null | undefined): string {
  if (!rail) return "";
  return rail.kind === "stablecoin" ? networkShort(rail.network) : (t.suppliers.schemes[rail.scheme] ?? rail.scheme.toUpperCase());
}

export const COUNTRY_NAMES: Record<string, string> = {
  CN: "China", US: "EUA", HK: "Hong Kong", DE: "Alemanha", IT: "Itália", JP: "Japão", KR: "Coreia do Sul", TW: "Taiwan",
  VN: "Vietnã", IN: "Índia", TR: "Turquia", GB: "Reino Unido", ES: "Espanha", FR: "França", PT: "Portugal", MX: "México",
  AR: "Argentina", CL: "Chile", CO: "Colômbia", PY: "Paraguai", UY: "Uruguai", CA: "Canadá", AU: "Austrália", SG: "Singapura",
  TH: "Tailândia", ID: "Indonésia", MY: "Malásia", NL: "Holanda", BE: "Bélgica", CH: "Suíça", AE: "Emirados Árabes", BR: "Brasil",
};
export function countryName(iso: string | null | undefined): string {
  if (!iso) return "—";
  return COUNTRY_NAMES[iso.toUpperCase()] ?? iso.toUpperCase();
}

export function beneficiaryPlace(b: Pick<Beneficiary, "country"> & { address?: string | null }): string {
  return countryName(b.country);
}
